
import { defineComponent } from "vue";

export default defineComponent({
  name: "item-1",
  components: {},
});
